<h2 mat-dialog-title>View Feature Flag Details</h2>
<mat-dialog-content>
  <mat-tab-group backgroundColor="accent" class="flag-tab-group">
    <mat-tab *ngFor="let team of data.teams" label="{{team.team}}">
      <table>
        <thead>
          <td>Database</td>
          <td>Key</td>
          <td>Enabled Date</td>
          <td>Expired Date</td>
          <td>Days Old</td>
        </thead>
        <tr class="comment-row" *ngFor="let flag of team.flags" [class.old]="flag.daysOld>21">
          <td>{{flag.database}}</td>
          <td>{{flag.key}}</td>
          <td>{{flag.enabledDate | date:'MM/dd/yyyy'}}</td>
          <td>{{flag.expiredDate | date:'MM/dd/yyyy'}}</td>
          <td align="right">{{flag.daysOld}}</td>
        </tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>